export default "__VITE_ASSET__DvgqqfQZ__"